import { render, staticRenderFns } from "./SavedDownloadSettingsTab.vue?vue&type=template&id=62560491&scoped=true"
import script from "./SavedDownloadSettingsTab.vue?vue&type=script&lang=js"
export * from "./SavedDownloadSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./SavedDownloadSettingsTab.vue?vue&type=style&index=0&id=62560491&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62560491",
  null
  
)

export default component.exports